// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__GEdFz","selected":"Tabs_selected__RhP5P","tabDisabled":"Tabs_tabDisabled__Iz-Pk"};